import { isRouteErrorResponse, Link, useRouteError } from 'react-router-dom'
import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export default function ErrorPage() {
  const error = useRouteError()

  useEffect(() => {
    if (import.meta.env.PROD && !isRouteErrorResponse(error)) {
      Sentry.captureException(error)
    }
  }, [error])

  const notFound = isRouteErrorResponse(error) && error.status === 404
  const message =
    import.meta.env.DEV && error instanceof Error ? error.message : null

  return (
    <main className="bg-background grid min-h-screen place-items-center p-6">
      <div className="max-w-md text-center">
        <h1 className="text-base font-semibold">
          {notFound ? 'Page not found' : 'Something went wrong'}
        </h1>
        <p className="text-muted-foreground mt-2 text-sm">
          {notFound
            ? 'The page you were after does not exist.'
            : 'The error has been reported. Try reloading — most hiccups are transient.'}
        </p>
        {message && (
          <pre className="bg-surface text-muted-foreground mt-4 overflow-auto rounded-md p-3 text-left font-mono text-xs">
            {message}
          </pre>
        )}
        <Button asChild variant="outline" size="sm" className="mt-5">
          <Link to="/">Back to the app</Link>
        </Button>
      </div>
    </main>
  )
}
